import React from "react";
import s from "./confirmModal.scss";

import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";

import { warningFill } from "Icons/index";
import TranslatedString from "../TranslatedString";

const ConfirmModal = ({
  opened,
  handleClose,
  isLoading,
  textButton,
  text,
  title,
  action,
  subs,
  translate = false,
  isWarning = false,
  hideCancelButton = false,
  buttonColor = "red",
}) => {
  // Add Enter key handler
  const handleEnter = React.useCallback(
    (e) => {
      if (!opened || isLoading) return;
      e.preventDefault();
      action();
    },
    [opened, action, isLoading]
  );

  return (
    <Modal
      className={s.confirmModal}
      title={title}
      icon={warningFill}
      iconClassName={isWarning ? "" : s.icon}
      opened={opened}
      closeModal={handleClose}
      isWarning={isWarning}
      onEnter={handleEnter}
    >
      {translate ? (
        <div>
          <TranslatedString subs={subs}>{text}</TranslatedString>
        </div>
      ) : (
        <div>{text}</div>
      )}
      <div className={s.footer}>
        {hideCancelButton ? null : (
          <Button color="text" onClick={handleClose}>
            button.cancel
          </Button>
        )}

        <Button loading={isLoading} color={isWarning ? "outline" : buttonColor} onClick={action}>
          {textButton}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
